module.exports = __webpack_public_path__ + "static/img/10.6edd015.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/10.jpg
// module id = 7/wm
// module chunks = 15